var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTriangulos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 304.706,
    height: 54.483,
    viewBox: "0 0 304.706 54.483",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_30",
    "data-name": "Grupo 30",
    transform: "translate(-834 -1213.604)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pol\\xEDgono_1",
    "data-name": "Pol\\xEDgono 1",
    d: "M22.536,2.35a3,3,0,0,1,4.386,0l17.825,19.1A3,3,0,0,1,42.554,26.5H6.9A3,3,0,0,1,4.71,21.448Z",
    transform: "translate(954.69 1213.604) rotate(48)",
    fill: "#f2c80e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pol\\xEDgono_5",
    "data-name": "Pol\\xEDgono 5",
    d: "M22.536,2.35a3,3,0,0,1,4.386,0l17.825,19.1A3,3,0,0,1,42.554,26.5H6.9A3,3,0,0,1,4.71,21.448Z",
    transform: "translate(1054.69 1213.604) rotate(48)",
    fill: "#ff5079"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pol\\xEDgono_2",
    "data-name": "Pol\\xEDgono 2",
    d: "M22.536,2.35a3,3,0,0,1,4.386,0l17.825,19.1A3,3,0,0,1,42.554,26.5H6.9A3,3,0,0,1,4.71,21.448Z",
    transform: "translate(938.706 1232.338) rotate(135)",
    fill: "#6ea5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pol\\xEDgono_4",
    "data-name": "Pol\\xEDgono 4",
    d: "M22.536,2.35a3,3,0,0,1,4.386,0l17.825,19.1A3,3,0,0,1,42.554,26.5H6.9A3,3,0,0,1,4.71,21.448Z",
    transform: "translate(1038.706 1232.338) rotate(135)",
    fill: "#00aba6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pol\\xEDgono_19",
    "data-name": "Pol\\xEDgono 19",
    d: "M22.536,2.35a3,3,0,0,1,4.386,0l17.825,19.1A3,3,0,0,1,42.554,26.5H6.9A3,3,0,0,1,4.71,21.448Z",
    transform: "translate(1138.706 1232.338) rotate(135)",
    fill: "#b792d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pol\\xEDgono_3",
    "data-name": "Pol\\xEDgono 3",
    d: "M22.536,2.35a3,3,0,0,1,4.386,0l17.825,19.1A3,3,0,0,1,42.554,26.5H6.9A3,3,0,0,1,4.71,21.448Z",
    transform: "translate(852.735 1213.604) rotate(45)",
    fill: "#dd6435"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangulos);
export default __webpack_public_path__ + "static/media/Triangulos.d38d2f374eeef8308aa4e879516ebe03.svg";
export { ForwardRef as ReactComponent };